// extracted by mini-css-extract-plugin
export var arrows = "_s-6";
export var decrementer = "_s-a";
export var disabled = "_s-4";
export var error = "_s-1";
export var hiddenText = "_s-b";
export var incrementer = "_s-9";
export var input = "_s-8";
export var inputWrapper = "_s-0";
export var leadingIcon = "_s-c";
export var readonly = "_s-3";
export var regular = "_s-7";
export var small = "_s-5";
export var warning = "_s-2";